export default __webpack_public_path__ + "static/media/icon-menu-bonus.3b4b962e.svg";